import { FeatureFlag } from '@ps/web-core-enums';
import React from 'react';

import SportsDefaultTitle from '@swf/components/SportsDefaultTitle/SportsDefaultTitle';
import useFeature from '@swf/core/hooks/useFeature';

import Maintenance from './Maintenance/Maintenance';
import Migration from './Migration/Migration';

export const SportsMaintenance = () => {
  const isMigrationBanner = useFeature(FeatureFlag.ISPMigrationBanner);

  return (
    <>
      <SportsDefaultTitle />
      {isMigrationBanner ? <Migration /> : <Maintenance />}
    </>
  );
};

export default SportsMaintenance;
